/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import studioWorkspaceIdQuery, {
	type StudioWorkspaceIdLoaderQuery,
} from '@jira/project-pages__contextual-summary/src/ui/agentic-automations-banner/get-studio-workspace-id/__generated__/StudioWorkspaceIdLoaderQuery.graphql';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import parameters from './__generated__/JiraSoftwareSummaryAppQuery$parameters.ts';
import type { JiraSoftwareSummaryAppQuery } from './__generated__/JiraSoftwareSummaryAppQuery.graphql.ts';

type SummarySoftwareEntrypointComponent = EntryPointComponent<
	{
		summaryQuery: JiraSoftwareSummaryAppQuery;
		studioWorkspaceIdQuery?: StudioWorkspaceIdLoaderQuery;
	},
	{},
	{},
	{}
>;

export const summarySoftwareEntrypoint: EntryPoint<
	SummarySoftwareEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<SummarySoftwareEntrypointComponent>(
		/* webpackChunkName: "async-summary-software-entrypoint" */ './JiraSoftwareSummaryApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (projectKey == null) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				summaryQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectKey,
						scope: { project: { projectKey } },
						isFilterRefinementEnabled: expValEquals(
							'jira_add_harmonisation_filter_to_summary_view',
							'isEnabled',
							true,
							false,
						),
					},
				},
				...(fg('jira_agentic_automations_kill_switch')
					? {
							studioWorkspaceIdQuery: {
								options: {
									fetchPolicy: 'store-or-network' as const,
								},
								parameters: studioWorkspaceIdQuery,
								variables: {
									jiraSiteAri: `ari:cloud:jira::site/${cloudId}`,
								},
							},
						}
					: {}),
			},
		};
	},
});
